import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ContentSection } from 'src/shared/components/organisms/contentSection';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { Gift } from '../models/gift';

interface GiftDonorProps {
  gift: Gift;
}

export const GiftDetailDonorInfo = (props: GiftDonorProps) => {
  const { gift } = props;
  const { t } = useTranslation(['gift']);

  return (
    <ContentSection header={t('gift:donorHeader')}>
      <GridWrapper>
        <Grid item xs zeroMinWidth>
          <Typography component='div' sx={{ fontWeight: 500 }}>
            {t('gift:detailDonor.name')}
          </Typography>
          <Typography component='div'>
            {gift.firstName || '-'} {gift.lastName || '-'}
          </Typography>
          <Typography component='div' sx={{ fontWeight: 500, mt: 2 }}>
            {t('gift:detailDonor.personalIdentityNumber')}
          </Typography>
          <Typography component='div'>{gift.personalIdentityNumber || '-'}</Typography>
        </Grid>
        <Grid item xs zeroMinWidth>
          <Typography component='div' sx={{ fontWeight: 500 }}>
            {t('gift:detailDonor.email')}
          </Typography>
          <Typography component='div'>{gift.email_address || '-'}</Typography>
          <Typography component='div' sx={{ fontWeight: 500, mt: 2 }}>
            {t('gift:detailDonor.phone')}
          </Typography>
          <Typography component='div'>{gift.phone || '-'}</Typography>
        </Grid>
        <Grid item xs zeroMinWidth>
          <Typography component='div' sx={{ fontWeight: 500 }}>
            {t('gift:detailDonor.adress')}
          </Typography>
          <Typography component='div'>
            {gift.streetAddress_1 || '-'}
            <br />
            {gift.postalCode || '-'} {gift.city || '-'}
          </Typography>
        </Grid>
      </GridWrapper>
    </ContentSection>
  );
};
